import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const GetSchoolTeachers = async (SchoolID) => {
  try {
    const UsersCollection = collection(db, "Users");

    const q = query(
      UsersCollection,
      where("UserType", "==", "teacher"),
      where("SchoolID", "==", JSON.parse(localStorage.getItem("schoolId"))),
      where("IsDeleted", "==", false),
      where("IsVerified", "==", 1)
    );
    const TeachersSnapshot = await getDocs(q);

    let TeachersData = [];

    TeachersSnapshot.forEach((doc) => {
      TeachersData.push({ ...doc.data(), id: doc.id });
    });
    return TeachersData;
  } catch (error) {
    console.log(error);
  }
};

export default GetSchoolTeachers;
